import * as React from "react";

import { usePageVisibility } from "@shared/hooks";
import { VisibilityEvent } from "@shared/hooks/usePageVisible";

interface Props {
  events?: VisibilityEvent[];
  visible?: boolean;
  onVisibilityChange: (value: boolean) => void;
}

/**
 * This component is used to detect when the page is visible or not.
 * Basically, it's a wrapper for the usePageVisibility hook which use for backward compatible with class component.
 */
export const PageVisibility: React.FC<Props> = ({
  events = [],
  visible = false,
  onVisibilityChange,
}) => {
  const didMountRef = React.useRef(false);
  // Since this component had been using by <Editor>, therefore the initial focus will be located at iframe
  const isVisible = usePageVisibility(visible, events);

  React.useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }

    onVisibilityChange(isVisible);
  }, [isVisible, onVisibilityChange]);

  return <></>;
};
